import React, { useState } from 'react';
import './styles.scss';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Dropdown, DropdownItem, DropdownList } from '@cokitchen/cokitchen-components';
import { ArrowDownIcon } from 'cokitchen-icons';
import NewBusinessModal from '../new-business-modal';
import useDashboardContext from 'contexts/dashboard.context';
import { ROUTE_KEYS, STORAGE_KEYS } from 'utils/constants';
import HeaderBasket from 'components/header-basket';
import { CompaniesListType } from 'models/company.model';
import { isOnboardingCompleted } from 'utils/functions';

const Sidebar = () => {
  const navigate = useNavigate();
  const [showNewBusinessModal, setShowNewBusinessModal] = useState(false);
  const {
    setShowMobileSidebar,
    setActiveCompany,
    activeCompany,
    companyList,
    sidebarMenu,
    onboarding
  } = useDashboardContext();
  const { pathname } = useLocation();
  const company_name = activeCompany?.name ?? '-';
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedDropdown, setSelectedDropdownOpen] = useState('');

  const onboardingCompleted = isOnboardingCompleted(onboarding);

  const isLinkActive = (baseRoute?: string) => {
    return baseRoute && pathname.startsWith(`/${baseRoute}`);
  };
  const newBusinessModal = () => {
    setShowNewBusinessModal(!showNewBusinessModal);
  };
  const handleDropdownItemClick = (company: CompaniesListType) => {
    setSelectedDropdownOpen(() => company.name);
    setIsDropdownOpen(false);
    localStorage.setItem(STORAGE_KEYS.ADMIN_SKIPPED, company.skip ? 'YES' : 'NO');
    navigate(`/${ROUTE_KEYS.GET_STARTED}`);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <div className='sidebar sticky top-0'>
      <div className='max-lg:hidden'>
        <Dropdown
          visible={isDropdownOpen}
          onClickOutside={() => setIsDropdownOpen(false)}
          content={
            <div
              onClick={toggleDropdown}
              className='w-full flex items-center justify-between gap-4 flex-wrap cursor-pointer h-[64px] px-4 border-b border-b-[#EFF0F0]'>
              <div>
                <p className='font-medium text-[#2E3031]'>
                  {selectedDropdown ? selectedDropdown : company_name}
                </p>
                <div className='bg-[#EDFBEA] rounded-[20px] w-fit py-[1px] px-[10px]'>
                  <p className='text-[#3FB827] text-xs'>Active</p>
                </div>
              </div>
              <ArrowDownIcon className={`text-gray-8 ${isDropdownOpen ? 'rotate-180' : ''}`} />
            </div>
          }>
          <DropdownList>
            {companyList
              ?.filter((item) => item.id !== activeCompany?.id)
              .map((company) => (
                <DropdownItem
                  key={company.id}
                  className='font-medium'
                  onClick={() => {
                    setActiveCompany(company);
                    handleDropdownItemClick(company);
                  }}>
                  {company.name}
                </DropdownItem>
              ))}
          </DropdownList>
        </Dropdown>
      </div>

      <div className='sidebar_bottom px-4'>
        {sidebarMenu.map(({ name, icon, route, underline, onClick }) => (
          <div key={name}>
            <Link
              to={
                !onboardingCompleted && name !== 'Getting Started'
                  ? '#'
                  : route
                  ? `${ROUTE_KEYS.APP}/${route}`
                  : '#'
              }
              onClick={() => {
                if (onboardingCompleted) {
                  onClick?.();
                }
                setShowMobileSidebar(false);
              }}
              className={`   ${
                !onboardingCompleted && name !== 'Getting Started'
                  ? 'cursor-not-allowed'
                  : 'cursor-pointer'
              } sidebar_bottom_item ${isLinkActive(route) ? 'active' : 'inactive'}
           
              `}>
              <div className='icon'>{icon}</div>
              <p className='text-gray-9 font-medium text-sm'>{name}</p>
            </Link>
            {underline && <hr className='border-[#DDDEDF] border-opacity-50 mt-6 mb-4' />}
          </div>
        ))}
        <div className='block sm:hidden'>
          {pathname.includes(ROUTE_KEYS.ORDERS) && <HeaderBasket />}
        </div>
      </div>

      <NewBusinessModal show={showNewBusinessModal} onClose={newBusinessModal} />
    </div>
  );
};

export default Sidebar;
